import wildCardSearch from 'utils/wildCardSearch'
import sortBy from 'utils/sortBy'
import paginate from 'utils/paginate'

export default function salesFakeApi(server, apiPrefix) {
    server.post(`${apiPrefix}/campaigns/dashboard`, (schema) => {
        return schema.db.salesDashboardData[0]
    })

    server.post(`${apiPrefix}/campaigns/Campaigns`, (schema, { requestBody }) => {
        const body = JSON.parse(requestBody)
        const { pageIndex, pageSize, sort, query } = body
        const { order, key } = sort
        const Campaigns = schema.db.CampaignsData
        const sanitizeCampaigns = Campaigns.filter(
            (elm) => typeof elm !== 'function'
        )
        let data = sanitizeCampaigns
        let total = Campaigns.length

        if ((key === 'category' || key === 'name') && order) {
            data.sort(sortBy(key, order === 'desc', (a) => a.toUpperCase()))
        } else {
            data.sort(sortBy(key, order === 'desc', parseInt))
        }

        if (query) {
            data = wildCardSearch(data, query)
            total = data.length
        }

        data = paginate(data, pageSize, pageIndex)

        const responseData = {
            data: data,
            total: total,
        }
        return responseData
    })

    server.del(
        `${apiPrefix}/campaigns/Campaigns/delete`,
        (schema, { requestBody }) => {
            const { id } = JSON.parse(requestBody)
            schema.db.CampaignsData.remove({ id })
            return true
        }
    )

    server.get(`${apiPrefix}/campaigns/Campaign`, (schema, { queryParams }) => {
        const id = queryParams.id
        const Campaign = schema.db.CampaignsData.find(id)
        return Campaign
    })

    server.put(
        `${apiPrefix}/campaigns/Campaigns/update`,
        (schema, { requestBody }) => {
            const data = JSON.parse(requestBody)
            const { id } = data
            schema.db.CampaignsData.update({ id }, data)
            return true
        }
    )

    server.post(
        `${apiPrefix}/campaigns/Campaigns/create`,
        (schema, { requestBody }) => {
            const data = JSON.parse(requestBody)
            schema.db.CampaignsData.insert(data)
            return true
        }
    )

    server.get(`${apiPrefix}/campaigns/orders`, (schema, { queryParams }) => {
        const { pageIndex, pageSize, sort, query } = queryParams
        const { order, key } = JSON.parse(sort)
        const orders = schema.db.ordersData
        const sanitizeCampaigns = orders.filter(
            (elm) => typeof elm !== 'function'
        )
        let data = sanitizeCampaigns
        let total = orders.length

        if (key) {
            if (
                (key === 'date' ||
                    key === 'status' ||
                    key === 'paymentMehod') &&
                order
            ) {
                data.sort(sortBy(key, order === 'desc', parseInt))
            } else {
                data.sort(sortBy(key, order === 'desc', (a) => a.toUpperCase()))
            }
        }

        if (query) {
            data = wildCardSearch(data, query)
            total = data.length
        }

        data = paginate(data, pageSize, pageIndex)

        const responseData = {
            data: data,
            total: total,
        }
        return responseData
    })

    server.del(
        `${apiPrefix}/campaigns/orders/delete`,
        (schema, { requestBody }) => {
            const { id } = JSON.parse(requestBody)
            id.forEach((elm) => {
                schema.db.ordersData.remove({ id: elm })
            })
            return true
        }
    )

    server.get(
        `${apiPrefix}/campaigns/orders-details`,
        (schema, { queryParams }) => {
            const { id } = queryParams
            const orderDetail = schema.db.orderDetailsData
            orderDetail[0].id = id
            return orderDetail[0]
        }
    )
}
